import { el, mount, unmount } from 'redom';

import application from 'application';

import { stringToSVG } from 'utilities';
import {
  displayElementAroundAnchor
} from 'utilities/element-position';

import LiveChat from './help-menu/live-chat';

import unknownIconString from 'assets/images/unknown-file-icon.svg?raw';

import './index.scss';

const unknownIcon = stringToSVG(unknownIconString);

let widget = null;

class HelpWidget {

  constructor() {

    this.liveChatDisplayed = false;

    this.button = el('button#help-widget-button', {
      onclick: this.toggleHelpLiveChat.bind(this)
    }, [unknownIcon.cloneNode(true)]);

    this.el = el('#help-widget-main', [
      this.button,
    ]);

  }

  positionLiveChat(anchorElement) {

    const element = this.liveChat.el;
    const viewportElement = void 0;
    const verticalOffset = 5;
    const horizontalOffset = 0;
    const startSide = 'top';
    const placeOnCenter = false;
    const positionableSides = ['top'];

    displayElementAroundAnchor(element, anchorElement, viewportElement, verticalOffset, horizontalOffset, startSide, placeOnCenter, positionableSides);

  }

  async showLiveChat(anchorElement = this.button) {

    this.liveChatDisplayed = true;

    const result = await application.dialogsManager.display(LiveChat, {
      onClose: this.hideLiveChat.bind(this)
    }, {
      promptMode: true,
      contentHolderClassName: 'live-chat-dialog-content-holder',
      containerClassName: 'live-chat-dialog-container'
    });

    if (result.cancelled === true) {
      return;
    }

  }

  hideLiveChat() {}

  toggleHelpLiveChat() {

    this.showLiveChat();

  }

  update() {}

  static get() {

    if (widget === null) {
      widget = new HelpWidget();
    }

    return widget;

  }

}

export default HelpWidget;